<template>
  <el-dialog custom-class="min-dialog" title="续费" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :modal-append-to-body="false" :show-close="true" :closed="closedia">
    <div style="margin: auto;width: 250px;height: 20px;padding-top: 2px;font-size: 20px;">￥<b>{{form.money|numeric(2)}}元</b></div>
    <div id="qrcode" ref="paycode" style="margin: auto;width: 250px;height: 250px;padding-top: 15px;" v-show="loading"></div>
    <div id="showinfo" style="margin: auto;width: 250px;height: 20px;padding-top: 5px;" v-show="loading">请使用<span style="color: #ff6600;font-size:20px">微信</span>扫码支付<span style="color: blue">{{countdown.showinfo}}</span></div>
    <div style="margin: auto;width: 260px;height: 20px;padding-top: 5px;font-size: 11px" v-show="loading">支出成功后会自动跳转，如未跳转<el-button round @click="redirect()" size="mini">请点这里</el-button></div>
  </el-dialog>
</template>
<script>
  import {payTenantid,detailTenantid} from '../../api/login'
  import QRCode from 'qrcodejs2'

  export default {
    data() {
      return {
        dialogFormVisible: false,
        payMethod:"",
        loading:false,
        isdialog:false,
        form: {
          money:0.01,//金额
          qrurl:'',
        },
        countdown:{
          showinfo:'',
          count:60,
          timer:null,
        }
      };
    },
    methods: {
      show() {
        this.begtnPay();
      },
      begtnPay(){
        this.dialogFormVisible=true;
        this.loading=true;
        payTenantid().then(response => {
          if(response.data.code == 0) {
            this.form=JSON.parse(response.data.obj);
            this.waitpay();

          }else {
            this.loading=false;
            this.$message.error("订单不存在！");
          }
        }).catch((error) => {
          this.loading=false;
          console.log(error)
        });
      },
      waitpay(){//等待支付

        console.log(document.getElementById('qrcode'))
        document.getElementById('qrcode').innerHTML = '';

        //1、生成二维码
        let qrcode = new QRCode('qrcode', {
          width: 250,
          height: 250, // 高度
          text: this.form.qrurl, // 二维码内容
          correctLevel:QRCode.CorrectLevel.H
        })

        //2、支付倒计时
        this.countDown();
      },
      countDown(){//倒计时
        const TIME_COUNT = 60*5;
        if (!this.countdown.timer) {
          var self=this;
          self.countdown.count = TIME_COUNT;

          self.countdown.timer = setInterval(() => {
            if (self.countdown.count > 0 && self.countdown.count <= TIME_COUNT) {
              self.countdown.count--;

              var seconds = Math.floor(self.countdown.count % 60);
              var msg = '0'+(Math.floor(self.countdown.count / 60)) + " : " + (seconds<10?('0'+seconds):seconds);

              self.countdown.showinfo='（ '+msg+' ）';

              if(self.countdown.count<TIME_COUNT-10&&self.countdown.count%10==0){
                //检查是否支付成功
                var curTime = new Date();
                detailTenantid().then(response => {
                  if(response.data && response.data.code == 0) {//支付成功
                    var row=response.data.obj;
                    var endtime = new Date(Date.parse(row.enddatetime));
                    if (endtime > curTime) {
                      self.redirect();
                    }
                  }
                });
              }
            } else {
              self.redirect();
            }
          }, 1000)
        }
      },
      closedia(){
        this.countdown.showinfo='';
        clearInterval(this.countdown.timer);
        this.countdown.timer = null;
        this.loading=false;
      },
      redirect() {
        this.countdown.showinfo = '';
        clearInterval(this.countdown.timer);
        this.countdown.timer = null;
        this.loading = false;
        //this.$emit('afterPay');
        this.$alert('续费成功，请重新登录！', '续费成功', {
          confirmButtonText: '确定',
          showClose:false,
          callback: action => {
            //重新登录
            localStorage.removeItem("appguid");
            localStorage.removeItem("tenantid");
            localStorage.removeItem("hpapi_token");
            localStorage.removeItem("hpapi_tokenModel");
            localStorage.removeItem("hpapi_userInfoModel");
            this.$router.push({name: "login"});
          }
        });

      },
    },
    mounted() {

    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/ewmPay.vue